import React, { memo } from "react";
import { Button, Select } from "antd";
import { CloseButton } from "../../icons/CloseButton";
const { Option } = Select;

export const ScoreLinesFilter = memo(
    ({
         driverValues,
         selectedDriver,
         handleDriverChange,
         scoreLines,
         handleValueChange,
         removeLine,
         addLine,
         updateLineLabel,
     }) => {
        return (
            <div>
                <Select
                    style={{ width: "100%", marginBottom: 10 }}
                    placeholder="Select a driver"
                    value={selectedDriver}
                    onChange={handleDriverChange}
                >
                    {driverValues.map((driver) => (
                        <Option key={driver.name} value={driver.name}>
                            {driver.name}
                        </Option>
                    ))}
                </Select>

                {scoreLines.map((line) => (
                    <div
                        key={line.id}
                        style={{
                            borderBottom: "1px dashed #ccc",
                            paddingBottom: 10,
                            marginBottom: 10,
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            <input
                                type="text"
                                value={line.label}
                                defaultValue={`Line ${line.id}`}
                                onChange={(e) => updateLineLabel(line.id, e.target.value)}
                                style={{
                                    fontWeight: 600,
                                    marginRight: 8,
                                    width: "80%",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    padding: "4px",
                                }}
                            />
                            <Button
                                type="link"
                                danger
                                onClick={() => removeLine(line.id)}
                                icon={<CloseButton width={10} height={10} color={"red"} />}
                            />
                        </div>
                        <Select
                            mode="multiple"
                            allowClear
                            showSearch
                            style={{ width: "100%", marginBottom: 8 }}
                            placeholder="Select values"
                            value={line.selectedValues}
                            onChange={(values) => handleValueChange(line.id, values)}
                            options={
                                driverValues
                                    .find((driver) => driver.name === selectedDriver)
                                    ?.values?.map((val) => ({
                                    label: val.label || String(val.value),
                                    value: Number(val.value),
                                })) || []
                            }
                            size="small"
                            maxTagTextLength={20}
                            maxTagCount="responsive"
                        />
                    </div>
                ))}

                <Button type="dashed" onClick={addLine} block>
                    + Add line
                </Button>
            </div>
        );
    },
    (prevProps, nextProps) => {
        return (
            prevProps.driverValues === nextProps.driverValues &&
            prevProps.selectedDriver === nextProps.selectedDriver &&
            prevProps.scoreLines === nextProps.scoreLines
        );
    }
);

